import { ContractKeyGroup } from '@cube3/common/model/schema/resources/contract-key-group';
import { MetadataCategory } from '@cube3/common/model/schema/resources/metadata-category';
import { makeMetadataFields } from '@cube3/forms/src/utils/makeMetadataFields';
import React from 'react';

// add validators, additional data props, etc
export const useFormatMetadataCategory = (
  category: MetadataCategory | ContractKeyGroup,
  /** force to be required (exp: youtube export fields) */
  forceRequired = false
) => {
  return React.useMemo(
    () => makeMetadataFields(category, forceRequired),
    [category, forceRequired]
  );
};

// use for debug page: add validators, additional data props, etc
export const useFormatMetadataCategories = (
  categories: Array<MetadataCategory | ContractKeyGroup>
) => {
  return React.useMemo(() => {
    return categories.reduce((acc, category) => {
      const form = category.display_name;
      acc[form] = makeMetadataFields(category) ?? [];
      return acc;
    }, {});
  }, [categories]);
};
